import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@fgb/portal-component-library/src/lib/shared/sort-bar';
import { SortOrder, SortBarModule } from '@fgb/portal-component-library/src/lib/shared/sort-bar';
import { map } from 'rxjs/operators';
import * as i1 from '@fgb/core';
import * as i4 from '@fgb/portal-component-library/src/lib/shared/loading';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import * as i5 from '@fgb/portal-component-library/src/lib/loyalty/lottos/lottos-list-item';
import { LottosListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/lottos/lottos-list-item';
import * as i6 from '@fgb/portal-component-library/src/lib/directives';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import * as i7 from '@ngx-translate/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';

var LottoListSortOption;
(function (LottoListSortOption) {
    LottoListSortOption[LottoListSortOption["Ordinal"] = 0] = "Ordinal";
    LottoListSortOption[LottoListSortOption["Favourite"] = 1] = "Favourite";
    LottoListSortOption[LottoListSortOption["Points"] = 2] = "Points";
})(LottoListSortOption || (LottoListSortOption = {}));

class LottosListComponent {
    constructor(lottoQuery) {
        this.lottoQuery = lottoQuery;
        this.defaultSort = LottoListSortOption.Favourite;
        this.sortOrderType = SortOrder;
    }
    ngOnInit() {
        this.subscribeAndSortLottoItems();
        this.defineSortBarOptions();
    }
    subscribeAndSortLottoItems() {
        this.lottos$ = this.lottoQuery.selectLottos().pipe(map((m) => m.sort((a, b) => {
            switch (this.defaultSort) {
                case LottoListSortOption.Favourite:
                    return this.sortByFavourite(a, b);
                case LottoListSortOption.Ordinal:
                    return this.sortByOrdinal(a, b);
                case LottoListSortOption.Points:
                    return this.sortByPoints(a, b);
                default:
                    return 0;
            }
        })));
    }
    sortByFavourite(a, b) {
        return b.Favourite - a.Favourite;
    }
    sortByOrdinal(a, b) {
        return a.Ordinal - b.Ordinal;
    }
    sortByPoints(a, b) {
        return a.PurchasePrice - b.PurchasePrice;
    }
    defineSortBarOptions() {
        this.sortBarOptions = [
            {
                propertyToSort: 'PurchasePrice',
                shouldToggle: false,
                order: this.sortOrderType.Descending,
                labelDESC: 'lotto.high.low',
            },
            {
                propertyToSort: 'PurchasePrice',
                shouldToggle: false,
                order: this.sortOrderType.Ascending,
                labelASC: 'lotto.low.high',
            },
            {
                propertyToSort: 'AvailableCount',
                shouldToggle: true,
                order: this.sortOrderType.Descending,
                labelASC: 'lotto.limited.availability',
                labelDESC: 'lotto.high.availability',
            },
            {
                propertyToSort: 'Title',
                shouldToggle: true,
                order: this.sortOrderType.Descending,
                labelASC: 'lotto.a.z',
                labelDESC: 'lotto.z.a',
            },
        ];
    }
    resetOrder() {
        this.subscribeAndSortLottoItems();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LottosListComponent, deps: [{ token: i1.LottoQuery }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: LottosListComponent, selector: "fgbcl-lottos-list", inputs: { isList: "isList", defaultSort: "defaultSort" }, ngImport: i0, template: "<div [class.row]=\"isList\">\r\n  <ng-container *ngIf=\"lottos$ | async as lottos; else loadingRef\">\r\n    <ng-container *ngIf=\"lottos.length; else noLottos\">\r\n      <ng-container *fgbWebsiteContentFeatureFlag=\"'fgbcl.feature.flag.lotto.sortbar'\">\r\n        <fgbcl-sort-bar\r\n          class=\"row w-100\"\r\n          [sortBarOptions]=\"sortBarOptions\"\r\n          [itemList]=\"lottos\"\r\n          [displayDefaultSort]=\"true\"\r\n          (defaultSortAction)=\"resetOrder()\"\r\n        ></fgbcl-sort-bar>\r\n      </ng-container>\r\n      <div *ngFor=\"let item of lottos\" [class.col-6]=\"isList\" [class.col-lg-4]=\"isList\">\r\n        <div class=\"loyalty-item-container\">\r\n          <fgbcl-lottos-list-item [lottoItem]=\"item\"></fgbcl-lottos-list-item>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n\r\n<!-- No results -->\r\n<ng-template #noLottos>\r\n  <div class=\"no-items w-100 mt-4 no-results-placeholder-div\">\r\n    <div class=\"no-results-placeholder\">{{ 'lotto.placeholder.description' | translate }}</div>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- Loading -->\r\n<ng-template #loadingRef>\r\n  <div class=\"w-100\">\r\n    <fgbcl-loading></fgbcl-loading>\r\n  </div>\r\n</ng-template>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.SortBarComponent, selector: "fgbcl-sort-bar", inputs: ["sortBarOptions", "itemList", "displayDefaultSort"], outputs: ["defaultSortAction"] }, { kind: "component", type: i4.LoadingComponent, selector: "fgbcl-loading", inputs: ["size"] }, { kind: "component", type: i5.LottosListItemComponent, selector: "fgbcl-lottos-list-item", inputs: ["lottoItem", "ignoreLink", "isPreview"] }, { kind: "directive", type: i6.WebsiteContentFeatureFlagDirective, selector: "[fgbWebsiteContentFeatureFlag]", inputs: ["fgbWebsiteContentFeatureFlag"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }, { kind: "pipe", type: i7.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LottosListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-lottos-list', template: "<div [class.row]=\"isList\">\r\n  <ng-container *ngIf=\"lottos$ | async as lottos; else loadingRef\">\r\n    <ng-container *ngIf=\"lottos.length; else noLottos\">\r\n      <ng-container *fgbWebsiteContentFeatureFlag=\"'fgbcl.feature.flag.lotto.sortbar'\">\r\n        <fgbcl-sort-bar\r\n          class=\"row w-100\"\r\n          [sortBarOptions]=\"sortBarOptions\"\r\n          [itemList]=\"lottos\"\r\n          [displayDefaultSort]=\"true\"\r\n          (defaultSortAction)=\"resetOrder()\"\r\n        ></fgbcl-sort-bar>\r\n      </ng-container>\r\n      <div *ngFor=\"let item of lottos\" [class.col-6]=\"isList\" [class.col-lg-4]=\"isList\">\r\n        <div class=\"loyalty-item-container\">\r\n          <fgbcl-lottos-list-item [lottoItem]=\"item\"></fgbcl-lottos-list-item>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n\r\n<!-- No results -->\r\n<ng-template #noLottos>\r\n  <div class=\"no-items w-100 mt-4 no-results-placeholder-div\">\r\n    <div class=\"no-results-placeholder\">{{ 'lotto.placeholder.description' | translate }}</div>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- Loading -->\r\n<ng-template #loadingRef>\r\n  <div class=\"w-100\">\r\n    <fgbcl-loading></fgbcl-loading>\r\n  </div>\r\n</ng-template>\r\n" }]
        }], ctorParameters: () => [{ type: i1.LottoQuery }], propDecorators: { isList: [{
                type: Input
            }], defaultSort: [{
                type: Input
            }] } });

class LottosListModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LottosListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: LottosListModule, declarations: [LottosListComponent], imports: [CommonModule,
            ErrorsModule,
            SortBarModule,
            LoadingModule,
            LottosListItemModule,
            DirectivesModule,
            FGBSharedModule], exports: [LottosListComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LottosListModule, imports: [CommonModule,
            ErrorsModule,
            SortBarModule,
            LoadingModule,
            LottosListItemModule,
            DirectivesModule,
            FGBSharedModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LottosListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LottosListComponent],
                    imports: [
                        CommonModule,
                        ErrorsModule,
                        SortBarModule,
                        LoadingModule,
                        LottosListItemModule,
                        DirectivesModule,
                        FGBSharedModule
                    ],
                    exports: [LottosListComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LottoListSortOption, LottosListComponent, LottosListModule };
